import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs';
import { CommonStaffApiServiceService } from '../../common-staff-api-service.service';
import { ToasterService } from '../../../../providers/toaster/toaster.service';
import { LoaderComponent } from "../../../../providers/loader.component";
import { StaffStudentCommonProfileViewComponent } from "../../../../components/personnel-component/staff-student-common-profile-view/staff-student-common-profile-view.component";

@Component({
  selector: 'app-staff-details',
  standalone: true,
  imports: [CommonModule, LoaderComponent, StaffStudentCommonProfileViewComponent],
  templateUrl: './staff-details.component.html',
  styleUrl: './staff-details.component.css'
})
export class StaffDetailsComponent {
  staffId: number | string | null = null;
  staffData: any = null;
  isFetching: boolean = false;

  activityLog = [
    { date: '28-Dec-24', time: '03:16 pm', text: 'New Student Created', status: 'success' },
    { date: '27-Dec-24', time: '03:16 pm', text: 'Password Changed', status: 'success' },
    { date: '25-Dec-24', time: '03:16 pm', text: 'Video Streamed for Class 7C - completed on 04:20 pm', status: 'success' },
    { date: '25-Dec-24', time: '03:16 pm', text: 'Deleted Student - Prajakta Bhavsar BA', status: 'error' },
    { date: '25-Dec-24', time: '03:16 pm', text: 'Added Remark for \"Complete video of Port\" for class 5A', status: 'success' },
    { date: '25-Dec-24', time: '03:16 pm', text: 'Made Test live for Students', status: 'success' },
    { date: '25-Dec-24', time: '03:16 pm', text: 'Made Test live for Students', status: 'success' }
  ];

  constructor(
    private route: ActivatedRoute,
    private staffApiService: CommonStaffApiServiceService,
    private toasterService: ToasterService
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      this.staffId = id;
      if (!id) {
        this.staffData = null;
        return;
      }
      this.fetchStaffDetails(id);
    });
  }

  fetchStaffDetails(id: number | string) {
    this.isFetching = true;
    this.staffApiService.getStaffProfile(id)
      .pipe(finalize(() => { this.isFetching = false; }))
      .subscribe({
        next: (res: any) => {
          if (res?.status === 'success') {
            this.staffData = res?.data ?? null;
          } else {
            this.staffData = null;
            this.toasterService.setToaster('error', 'Error', res?.message ?? 'Failed to fetch staff details');
          }
        },
        error: (err) => {
          console.error('HTTP error:', err);
          this.staffData = null;
          this.toasterService.setToaster('error', 'Error', 'Failed to fetch staff details');
        }
      });
  }
}
